<script>
	import { page } from '$app/stores';
	import { variables } from '$lib/variables';
	import { onDestroy, onMount } from 'svelte';

	let authContainer;
	/**
	 * @param {any} authData
	 */
	async function SendTeleGramAuth(authData) {
		let url = `${variables.basePathApi}/users/auth/telegram/`;

		const res = await fetch(url, {
			method: 'POST',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(authData)
		});
		if (res.status == 200) {
			const json = await res.json();

			const resLogin = await fetch('/auth/login', {
				method: 'POST',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(json)
			});
			if (resLogin.status == 200) {
			}
			// Cookies.set('access', json.access, { expires: 1 });
			// Cookies.set('refresh', json.refresh, { expires: 1 });
			setTimeout(() => {
				let urlred = $page.url.searchParams.get('pathname') || '/';
				if ($page.url.searchParams.get('open_basket')) {
					urlred = `${urlred}?open_basket=1`;
				}
				location.href = urlred;
			}, 200);
		} else {
			alert('Ошибка сервера');
		}
	}
	onMount(() => {
		// if (process.env.NODE_ENV === 'production') {
		// Вставьте ваш скрипт после монтирования компонента
		let script = document.createElement('script');
		script.src = 'https://telegram.org/js/telegram-widget.js?22';
		script.dataset.telegramLogin = 'iloveitalianbags_bot';
		script.dataset.size = 'large';
		script.dataset.onauth = 'onTelegramAuth(user)';
		script.dataset.requestAccess = 'write';
		script.async = true;
		authContainer.appendChild(script);

		window.onTelegramAuth = function (user) {
			SendTeleGramAuth(user);
		};
		// }
	});

	// Функция отчистки при демонтировании компонента
	onDestroy(() => {
		delete window.onTelegramAuth;
	});
</script>

<div bind:this={authContainer} />
